import { render, staticRenderFns } from "./PriceListsList.vue?vue&type=template&id=475898f5&"
import script from "./PriceListsList.vue?vue&type=script&lang=js&"
export * from "./PriceListsList.vue?vue&type=script&lang=js&"
import style0 from "./PriceListsList.vue?vue&type=style&index=0&id=475898f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports